import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('tokenApi')}`
  });
  constructor(private http: HttpClient) {
  }

  generarPDF(html: string, title: string, state: string) {
    let watermark = true;
    if (state == "Finalizado") {
      watermark = false
    }
    let datos = {
      "html": `${html}`,
      "type": title,
      "state": `${state}`,
      "watermark": `${watermark}`
    }

    return this.http.post(environment.urlBack + '/pdf/get', datos, { reportProgress: true, responseType: 'blob' as 'blob', observe: 'response', headers: this.headers }).pipe(tap(
      (res: any) => {
        return res;
      }));

  }


  setData(data: any) {
    localStorage.setItem('username', data.userName)
    localStorage.setItem('roles', JSON.stringify(data.userInfoDTOs))
  }

  getUsername() {
    return localStorage.getItem('username');
  }
  setUserCategories(data: any) {
    localStorage.setItem('userCategories', JSON.stringify(data.user.categories))
  }

  getUserCategories() {
    return localStorage.getItem('userCategories');
  }
  setToken(token: string) {
    localStorage.setItem('token', token)
  }

  setTokenApi(token: string) {
    localStorage.setItem('tokenApi', token)
  }
  isLoggedIn() {
    return localStorage.getItem('tokenApi');
  }

  clear() {
    localStorage.clear();
  }

  getRoles() {
    
    let info = JSON.parse(localStorage.getItem('roles'))
    console.log(info)

    let array = [];
    if (info) {
      info.forEach(i => {
        array.push(i.puesto?.toUpperCase());
      })
    }

    return array;
  }
  getSections() {
    let info = JSON.parse(localStorage.getItem('roles'))
    let array: string[] = [];
    const seccionesUnicas = new Set<string>();
  
    if (info) {
      info.forEach(i => {
        const seccion = i.seccion;
        if (seccion && !seccionesUnicas.has(seccion)) {
          seccionesUnicas.add(seccion);
          array.push(seccion);
        }
      });
    }
    
    return array;
  }
  getToken() {
    return localStorage.getItem('token');
  }
  hasRole() {
    let roles = this.getRoles();
    if (roles && (roles.includes('EJECUTOR') || roles.includes('JEFE DE SECCIÓN') || roles.includes('ANALISTA DE MANTENIMIENTO'))
    ) {
      return true;
    }
    return false;
  }
}







